<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="initialize"
                >
                    Refresh Data
                </responsiveButton>
                <v-divider class="mx-6"></v-divider>
                <v-data-table
                        :headers="reportTable.headers"
                        :items="reports"
                        :loading="loading"
                        loading-text="Loading... Please wait"
                        class="elevation-1"
                        :options.sync="pagination"
                        :server-items-length="totalItems"
                >
                    <template v-slot:item.required = "{item}">
                        <v-chip :color="item.required ? 'green' : 'red'" class="white-span" text-color="white">
                            {{ item.required ? 'Yes' : 'No' }}
                        </v-chip>
                    </template>
                    <template v-slot:item.approvalRequired = "{item}">
                        <v-chip :color="item.approvalRequired ? 'green' : 'red'" class="white-span" text-color="white">
                            {{ item.approvalRequired ? 'Yes' : 'No' }}
                        </v-chip>
                    </template>
                    <template v-slot:item.notificationInterval = "{item}">
                        {{getReportFrequency(item)}}
                    </template>

                    <!--actions-->
                    <template v-slot:item.clone="{item}">
                        <v-icon
                                class="mr-2"
                                @click="cloneReport(item)"
                        >
                            mdi-content-copy
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <dialog-alert
                :text="confirmAlertText"
                :alert-type="confirmAlertType"
                :open="openConfirmation"
                @alert-closed="dialogClosed($event)"
        ></dialog-alert>
    </v-container>

</template>

<script>
    import {DOCUMENT_RULE_TYPES} from "@/shared/enums/DocumentRule";
    import {FREQUENCIES} from "@/shared/enums/Report";

    const alertEventBus = ()=> import( '@/eventBus/AlertEventBus');
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const DialogAlert = () => import("@/components/common/DialogAlert");
    import { ALERT_TYPES, CONFIRM_DELETE } from "@/shared/enums/AlertTexts";

    export default {
        name: "reportTable",
        components: { responsiveButton, DialogAlert },
        data(){
            return {
                reports: [],
                loading: true,
                reportTable: {
                    headers: [
                        {
                            text: 'Name',
                            align: 'left',
                            sortable: true,
                            value: 'name'
                        },
                        {
                            text: 'Required',
                            align: 'center',
                            sortable: true,
                            value: 'required'
                        },
                        {
                            text: 'Requires Approval',
                            align: 'center',
                            sortable: true,
                            value: 'approvalRequired'
                        },
                        {
                            text: 'Frequency',
                            align: 'center',
                            sortable: true,
                            divider: true,
                            value: 'notificationInterval'
                        },
                        {
                            text: 'Clone',
                            align: 'center',
                            width: '2%',
                            value: 'clone',
                            sortable: false
                        }
                    ]
                },
                confirmAlertType: ALERT_TYPES.CONFIRM,
                confirmAlertText: CONFIRM_DELETE,
                openConfirmation: false,
                reportTypeToDelete: null,
                pagination: {},
                pageKeyCache: new Map(),
                totalItems: 0
            };
        },
        watch: {
            pagination: {
                async handler() {
                    await this.getReports();
                },
                deep: true
            },
        },
        methods:{
            initialize() {
                this.getReports();
            },
            async getReports() {
                this.loading = true;

                let params = this.getPaginationValues();

                if(!params.limit)
                    return;

                params.type = DOCUMENT_RULE_TYPES.REPORT;

                try{
                    await this.$store.dispatch('getDocumentRules',params);
                    this.reports = this.$store.getters.getDocumentRules;
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }

                this.setPaginationValues(this.reports);

                this.loading = false;
            },
            setPaginationValues(list){
                let key = this.$store.getters.getReportsPageKey;
                const {page} = this.pagination;

                if(key != null && Object.keys(key).length > 0){
                    this.pageKeyCache.set(page, key);
                    this.totalItems = list.length +1;
                }
                else{
                    this.totalItems = list.length;
                }
            },
            getPaginationValues(){
                //all values of pagination that can be used for backend
                const { page, itemsPerPage } = this.pagination;
                let params = {
                    limit: itemsPerPage
                }

                if(this.pageKeyCache.has(page) && page != 1){
                    params.lastEvaluatedKey = this.pageKeyCache.get(page);
                }
                else {
                    //we have not been there yet, so it needs to be to cases 1: this is brand new search page 0
                    // or it is the next page that we has not seem
                    if(page != 1) {
                        params.lastEvaluatedKey = this.pageKeyCache.get(page-1);
                    }
                }
                return params;
            },
            async cloneReport(report){
                this.$store.commit('setDocumentRule',{...report})
                this.$router.push({name:'reportClone',params: {id:report.id}});
            },
            getReportFrequency(report){
                return FREQUENCIES.getFrequencyReadable(report.notificationInterval);
            },
            async deleteReport(report){
                const index = this.reports.indexOf(report);

                await this.$store.dispatch('deleteDocumentRule',{id:report.id});
                let response = this.$store.getters.getReport;

                this.reports.splice(index, 1);
                this.reportTypeToDelete = null;
            },
            confirmDelete(item) {
                this.openConfirmation = true;
                this.reportTypeToDelete = item;
            },
            dialogClosed(answer) {
                this.openConfirmation = false;
                if (answer) {
                    this.deleteReport(this.reportTypeToDelete);
                }
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>